import axios from 'axios'

class SignatureProfileService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }
  /**
  * @author Lucia Alvarado
  * @description Get all signature profiles of user 
  * @date 18-01-2022
  * @param {String} token
  * @param {Number} userId
  * @returns {Object}
  * @memberof SignatureProfileService
  */
  async getSignatureProfilesUserId(token, userId) {
    let response = await axios.get(`${this.apiUrl}/signature-profiles?userId=${userId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  async getSignatureProfilesById(token, id) {
    let response = await axios.get(`${this.apiUrl}/signature-profile?id=${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Gustavo Adolfo
  * @description Get all signature profiles by microserviceId
  * @updatedDate 18-01-2022
  * @param {String} token
  * @param {Number} userId
  * @returns {Object}
  * @memberof SignatureProfileService
  */
  async getSignatureProfiles(token, microserviceId) {
    if (!microserviceId) microserviceId = 2
    let response = await axios.get(`${this.apiUrl}/signature-profiles?microserviceId=${microserviceId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }


  /**
  * @author Gustavo Adolfo
  * @description Get a signature profiles by id
  * @updatedDate 18-01-2022
  * @param {String} token
  * @param {Number} userId
  * @returns {Object}
  * @memberof SignatureProfileService
  */
  async getSignatureProfilesById(token, id) {
    let response = await axios.get(`${this.apiUrl}/signature-profile?id=${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Gustavo Adolfo
  * @description Create a signature profile
  * @updatedDate 18-01-2022
  * @param {String} token
  * @param {Number} userId
  * @returns {Object}
  * @memberof SignatureProfileService
  */
  async createSigatureProfiles(token, {
    microserviceId,
    name,
    description,
    icon,
    numberDaysLimit,
    defaultName,
    defaultDescription,
    defaultComments,
    processRandom,
    processSequential,
    processAprovation,
    processAprovationSequential,
    serviceConservationMessage,
    serviceTimeStamp,
    signatureTypeESign,
    signatureTypeAdvance,
    signatureTypeAutograph,
    documentProfile,
    proofOfLife,
    faceRecognition,
    dataClassifier
  }) {
    let data = new FormData()
    let response = await axios.post(`${this.apiUrl}/signature-profile`, {
      microserviceId,
      name,
      description,
      icon,
      numberDaysLimit,
      defaultName,
      defaultDescription,
      defaultComments,
      processRandom,
      processSequential,
      processAprovation,
      processAprovationSequential,
      serviceConservationMessage,
      serviceTimeStamp,
      signatureTypeESign,
      signatureTypeAdvance,
      signatureTypeAutograph,
      documentProfile,
      proofOfLife,
      faceRecognition,
      dataClassifier
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Gustavo Adolfo
  * @description Update a signature profile
  * @updatedDate 18-01-2022
  * @param {String} token
  * @param {Number} userId
  * @returns {Object}
  * @memberof SignatureProfileService
  */
  async changeSigatureProfiles(token, {
    id,
    name,
    description,
    icon,
    numberDaysLimit,
    defaultName,
    defaultDescription,
    defaultComments,
    processRandom,
    processSequential,
    processAprovation,
    processAprovationSequential,
    serviceConservationMessage,
    serviceTimeStamp,
    signatureTypeESign,
    signatureTypeAdvance,
    signatureTypeAutograph,
    documentProfile,
    proofOfLife,
    faceRecognition,
    dataClassifier
  }) {
    let response = await axios.put(`${this.apiUrl}/signature-profile`, {
      id,
      name,
      description,
      icon,
      numberDaysLimit,
      defaultName,
      defaultDescription,
      defaultComments,
      processRandom,
      processSequential,
      processAprovation,
      processAprovationSequential,
      serviceConservationMessage,
      serviceTimeStamp,
      signatureTypeESign,
      signatureTypeAdvance,
      signatureTypeAutograph,
      documentProfile,
      proofOfLife,
      faceRecognition,
      dataClassifier
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Gustavo Adolfo
  * @description Delete a signature profile by id
  * @updatedDate 18-01-2022
  * @param {String} token
  * @param {Number} userId
  * @returns {Object}
  * @memberof SignatureProfileService
  */
  async deleteSigatureProfiles(token, id) {
    let response = await axios.delete(`${this.apiUrl}/signature-profile?id=${id}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    return response.data
  }

  /**
  * @author Pedro Antonio
  * @description Get document profiles
  * @updatedDate 07-02-2024
  * @param {String} token
  * @returns {Object}
  * @memberof SignatureProfileService
  */
  async getDocumentProfiles(token) {
    let response = await axios.get(`${this.apiUrl}/signature-document-profiles`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    return response.data
  }

}
export { SignatureProfileService as default }